'use client';
import { useRef } from 'react';
import Layout from '../Components/Layout/Layout';
import Sidebar from './components/Sidebar';
import MobileFilterBar from './components/MobileFilterBar';
import HeroBanner from './components/HeroBanner';
import TopBar from './components/TopBar';
import ProductCard from './components/ProductCard';
import { supplements } from './data/supplements';
import { useShopAnimation } from './hooks/useShopAnimation';
import { useFilterBar } from './hooks/useFilterBar';
import { useParallaxScroll } from './hooks/useParallaxScroll';
import styles from './shop.module.css';
import CartTicket from '../Components/Navbar/CartTicket';

export default function Shop() {
  const gridRef = useRef(null);
  const cardsRef = useRef([]);
  const filterRef = useRef(null);

  // Custom hooks
  useShopAnimation(cardsRef, styles);
  useParallaxScroll(cardsRef);
  const { activeFilter, filterHoverStyle, handleFilterClick } = useFilterBar(filterRef);

  return (
    <Layout>
      
      <div className={styles.shopContainer}>
        <CartTicket/>
        {/* Floating Marquee Background */}

        <main className={styles.mainContent}>
          {/* Premium Hero Banner */}
          <HeroBanner />
          {/* Mobile Filter Bar */}
          <MobileFilterBar
            filterRef={filterRef}
            filterHoverStyle={filterHoverStyle}
            activeFilter={activeFilter}
            onFilterClick={handleFilterClick}
          />
          {/* Top Bar with Sort */}
          <TopBar />

          {/* Radial Gradient Background */}
          <div className={styles.radial}></div>

          {/* Products Grid */}
          <div ref={gridRef} className={styles.productsGrid}>
            {supplements.map((supplement, index) => (
              <ProductCard
                key={supplement.id}
                supplement={supplement}
                cardRef={el => cardsRef.current[index] = el}
              />
            ))}
          </div>
        </main>
      </div>
    </Layout>
  );
}
